module.exports = __webpack_public_path__ + "img/ico-presale.1dd46c51.svg";